import React from "react";

function CircleIcon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="-14 -5 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M4.147.009c-.87.082-1.519.326-2.182.822a5.6 5.6 0 0 0-.708.699A4.05 4.05 0 0 0 .44 3.45a5.3 5.3 0 0 0 0 1.095c.113.731.375 1.346.817 1.92.134.174.535.57.708.699a4.04 4.04 0 0 0 1.98.803c.226.029.742.025.967-.008a4 4 0 0 0 1.979-.84A4 4 0 0 0 8.339 4.68c.066-.372.073-.883.018-1.245A4 4 0 0 0 4.875.03a7 7 0 0 0-.728-.021"
        fill={fill ?? ""}
        fill-rule="evenodd"
      />
    </svg>
  );
}

export default CircleIcon;
